var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48291(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1601,
    height: 1001,
    viewBox: "0 0 1601 1001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48291",
    "data-name": "Group 48291",
    transform: "translate(-332.5 -2225.204)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37566",
    "data-name": "Path 37566",
    d: "M303.26,264.746h-82.4a5.356,5.356,0,0,1-5.362-5.362V176.962a5.356,5.356,0,0,1,5.362-5.362h82.422a5.356,5.356,0,0,1,5.362,5.362v82.422A5.392,5.392,0,0,1,303.26,264.746Z",
    transform: "translate(374.158 2374.386)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37567",
    "data-name": "Path 37567",
    d: "M305.726,267.363H221.013a5.507,5.507,0,0,1-5.513-5.513V177.113a5.507,5.507,0,0,1,5.513-5.513h84.738a5.507,5.507,0,0,1,5.513,5.513v84.738A5.543,5.543,0,0,1,305.726,267.363Z",
    transform: "translate(1493.665 2908.377)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37568",
    "data-name": "Path 37568",
    d: "M322.455,285.119H222.035a6.528,6.528,0,0,1-6.535-6.535V178.135a6.528,6.528,0,0,1,6.535-6.535H322.484a6.528,6.528,0,0,1,6.535,6.535V278.584A6.571,6.571,0,0,1,322.455,285.119Z",
    transform: "translate(1563.617 2054.104)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37569",
    "data-name": "Path 37569",
    d: "M585.707,521.509H536.776a3.174,3.174,0,0,1-3.176-3.176V469.376a3.174,3.174,0,0,1,3.176-3.176h48.931a3.174,3.174,0,0,1,3.176,3.176v48.931A3.2,3.2,0,0,1,585.707,521.509Z",
    transform: "translate(129.75 2178.668)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37570",
    "data-name": "Path 37570",
    d: "M582.823,518.448H536.6a3,3,0,0,1-3-3V469.2a3,3,0,0,1,3-3h46.223a3,3,0,0,1,3,3v46.223A3.019,3.019,0,0,1,582.823,518.448Z",
    transform: "translate(1253.157 2685.636)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37571",
    "data-name": "Path 37571",
    d: "M591.95,528.135H537.156a3.554,3.554,0,0,1-3.556-3.556V469.757a3.554,3.554,0,0,1,3.556-3.556H591.95a3.554,3.554,0,0,1,3.556,3.556v54.793A3.579,3.579,0,0,1,591.95,528.135Z",
    transform: "translate(1337.494 1844.686)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37572",
    "data-name": "Path 37572",
    d: "M1807.326,351.073h-57.18a6.24,6.24,0,0,1-6.247-6.247V287.647a6.24,6.24,0,0,1,6.247-6.247h57.18a6.24,6.24,0,0,1,6.247,6.247v57.179A6.223,6.223,0,0,1,1807.326,351.073Z",
    transform: "translate(-542.25 2456.118)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37573",
    "data-name": "Path 37573",
    d: "M1818.248,363.071h-67.026a7.314,7.314,0,0,1-7.323-7.323V288.723a7.314,7.314,0,0,1,7.323-7.323h67.026a7.314,7.314,0,0,1,7.323,7.323v67.025A7.294,7.294,0,0,1,1818.248,363.071Z",
    transform: "translate(-1410.9 2796.791)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37574",
    "data-name": "Path 37574",
    d: "M2029.5,496.645H1886.667a8.259,8.259,0,0,1-8.267-8.267V451.667a8.259,8.259,0,0,1,8.267-8.267H2029.5a8.259,8.259,0,0,1,8.267,8.267v36.711A8.294,8.294,0,0,1,2029.5,496.645Z",
    transform: "translate(-635.466 2362.151)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37575",
    "data-name": "Path 37575",
    d: "M2055.514,505.814H1888.091a9.681,9.681,0,0,1-9.691-9.691V453.091a9.681,9.681,0,0,1,9.691-9.691h167.423a9.681,9.681,0,0,1,9.691,9.691v43.032A9.722,9.722,0,0,1,2055.514,505.814Z",
    transform: "translate(-1503.489 2685.27)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37576",
    "data-name": "Path 37576",
    d: "M233.145,1369.99a25.645,25.645,0,1,1,25.645-25.645A25.666,25.666,0,0,1,233.145,1369.99Zm0-38.826a13.181,13.181,0,1,0,13.181,13.181A13.205,13.205,0,0,0,233.145,1331.164Z",
    transform: "translate(471.036 1855.714)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37577",
    "data-name": "Path 37577",
    d: "M233.145,1369.99a25.645,25.645,0,1,1,25.645-25.645A25.666,25.666,0,0,1,233.145,1369.99Zm0-38.826a13.181,13.181,0,1,0,13.181,13.181A13.205,13.205,0,0,0,233.145,1331.164Z",
    transform: "translate(155.756 973.016)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37578",
    "data-name": "Path 37578",
    d: "M233.145,1369.99a25.645,25.645,0,1,1,25.645-25.645A25.666,25.666,0,0,1,233.145,1369.99Zm0-38.826a13.181,13.181,0,1,0,13.181,13.181A13.205,13.205,0,0,0,233.145,1331.164Z",
    transform: "translate(1292.895 1839.714)",
    fill: "#0267c1",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1544",
    "data-name": "Ellipse 1544",
    transform: "translate(823.082 2815.754)",
    fill: "none",
    stroke: "blue",
    strokeWidth: 10,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    transform: "translate(687.606 2241)",
    fill: "none",
    stroke: "blue",
    strokeWidth: 10,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1546",
    "data-name": "Ellipse 1546",
    transform: "translate(1579.843 2448.357)",
    fill: "none",
    stroke: "blue",
    strokeWidth: 10,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1547",
    "data-name": "Ellipse 1547",
    transform: "translate(415.038 2723.477)",
    fill: "none",
    stroke: "blue",
    strokeWidth: 10,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1548",
    "data-name": "Ellipse 1548",
    transform: "translate(1839.454 2757.654)",
    fill: "none",
    stroke: "blue",
    strokeWidth: 10,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 12,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48291);
export default __webpack_public_path__ + "static/media/Group 48291.7f2978984d1438d5fb941e9ced6ed5a3.svg";
export { ForwardRef as ReactComponent };